import request from '@/utils/request'

// 查询公告管理列表
export function setSite(data) {
  return request({
      url: '/system/site/setSite',
      method: 'post',
      data: data
  })
}

// 查询公告管理列表
export function getSite(data) {
  return request({
      url: '/system/site/getSite',
      method: 'GET',
      params: data,
      data: data
  })
}